import { Divider, styled } from "@mui/material";

/**
 * The rule that separates one region of the product page from the next.
 *
 * Extracted from `Item.tsx` in EB-541 so that a region component can use it without importing from
 * the file that composes those regions — which would be a circular import.
 */
export const StyledDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.divider,
}));
